<img src="assets/icons/guide/left_click_move.svg" alt="left click" />
<img src="assets/icons/guide/scroll_wheel.svg" alt="scroll" />
<img src="assets/icons/guide/right_click_move.svg" alt="right click" />

<p>Click & hold with 1 finger or left mouse button to rotate</p>
<p>Scroll mouse wheel or pinch to zoom in and out</p>
<p>Click & hold with 2 fingers or right mouse button to pan</p>

<p class="dismiss">Click to dismiss...</p>
